import Backbone from 'backbone'
import nestCollection from 'scoreboard/components/nest-collection'

var DatasetField = Backbone.Model.extend(/** @lends DatasetField */{

	initialize: function(options) {
		this.ranges = new Backbone.Collection(this.get('ranges'))
		nestCollection({
			parent: this,
			parentAttribute: 'ranges',
			children: this.ranges
		})
	}

})

export default DatasetField

DatasetField.__filename__ = 'datasets/model/dataset-field.js'
